import React, { FC } from 'react';
import { Modal, Row, Col } from 'antd';
import { Button } from '@cloudcar-app/cloudcar-components';
import { QuestionCircleOutlined } from '@ant-design/icons';
import styles from './ConfirmModal.module.scss';

interface ConfirmModalProps {
  visible: boolean;
  handleOk: () => void;
  handleCancel: () => void;
  loading: boolean;
}

const ConfirmModal: FC<ConfirmModalProps> = (props: ConfirmModalProps) => {
  const { visible, handleOk, handleCancel, loading } = props;

  return (
    <Modal
      visible={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      width="30%"
      bodyStyle={{ padding: '36px 36px 24px 36px' }}
      style={{ top: '30%', bottom: '50%' }}
    >
      <Row justify="start" gutter={16}>
        <Col xs={2}>
          <QuestionCircleOutlined className={styles.Icon} />
        </Col>
        <Col xs={22}>
          <h3 className={styles.ConfirmModalTitle}>
            ¿Estás seguro que deseas continuar?
          </h3>
        </Col>
      </Row>
      <Row className={styles.ButtonRow} justify="end" gutter={8}>
        <Col>
          <Button onClick={handleCancel} mode="secondary">
            Cancelar
          </Button>
        </Col>
        <Col>
          <Button onClick={handleOk} loading={loading} disabled={loading}>
            Continuar
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default ConfirmModal;
